/**
 * Tipi di dominio per le capacità UI per ruolo (Admin — configurazione portale).
 *
 * Specchiano le definizioni del product-service:
 *   GET /api/products/admin/ui-capabilities
 *   PUT /api/products/admin/ui-capabilities
 */

import type { CraRole } from '../../auth/types.js';

/** Identificatore di una capacità UI del portale (catalogo fisso). */
export type UiCapability = 'dt_link' | 'prefect_jobs';

/** Catalogo fisso di tutte le capacità UI disponibili. */
export const UI_CAPABILITIES: readonly UiCapability[] = ['dt_link', 'prefect_jobs'] as const;

/** Etichette italiane delle capacità UI per la visualizzazione nella matrice. */
export const UI_CAPABILITY_LABELS: Record<UiCapability, string> = {
  dt_link: 'Link a Dependency-Track',
  prefect_jobs: 'Pagina Scheduled Job',
};

/** Mappa ruolo CRA → capacità UI abilitate. */
export type RoleCapabilitiesMap = Record<CraRole, UiCapability[]>;

/**
 * Verifica se almeno uno dei ruoli dell'utente ha la capacità richiesta
 * nella mappa configurata.
 *
 * @param roles     - Ruoli CRA dell'utente (dal JWT)
 * @param capability - Capacità UI da verificare
 * @param map       - Mappa ruolo → capacità corrente (dal server)
 * @returns true se almeno un ruolo ha la capacità
 */
export function hasCapability(
  roles: readonly CraRole[],
  capability: UiCapability,
  map: RoleCapabilitiesMap,
): boolean {
  return roles.some((role) => map[role]?.includes(capability) ?? false);
}
